module.exports = __webpack_public_path__ + "img/گوشه-تیز.8edf8dcd.jpg";